var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0535 10.2964L12.5052 13.744C12.8469 14.0854 13.4019 14.0854 13.7439 13.7437C14.0856 13.4023 14.0852 12.8478 13.7436 12.506L10.294 9.06108C10.988 8.11796 11.398 6.9534 11.398 5.69384C11.398 2.55138 8.84464 0 5.699 0C2.55368 0 0 2.55138 0 5.69384C0 8.83628 2.55368 11.3877 5.699 11.3877C6.95271 11.3877 8.11214 10.9825 9.0535 10.2964ZM5.699 1.75018C7.87798 1.75018 9.64662 3.51722 9.64662 5.69384C9.64662 7.87049 7.87798 9.63789 5.699 9.63789C3.5204 9.63789 1.75176 7.87049 1.75176 5.69384C1.75176 3.51722 3.5204 1.75018 5.699 1.75018Z",
    fill: "#E4151B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon3);
export default __webpack_public_path__ + "static/media/search-icon3.c0877338251c131b1e1ee1c4e52d426d.svg";
export { ForwardRef as ReactComponent };